import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item"];

  connect() {
    this.attachHoverListeners(this.itemTargets);
    this.observeDOM();
  }

  disconnect() {
    if (this.observer) this.observer.disconnect();
  }

  observeDOM() {
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          const candidates = node.matches?.("[data-hover-id]")
            ? [node]
            : node.querySelectorAll?.("[data-hover-id]") || [];

          this.attachHoverListeners(candidates);
        });
      });
    });

    this.observer.observe(this.element, {
      childList: true,
      subtree: true,
    });
  }

  attachHoverListeners(elements) {
    elements.forEach((el) => {
      if (el.dataset.hoverBound) return;
      el.dataset.hoverBound = "true";

      el.addEventListener("mouseenter", this.hoverIn);
      el.addEventListener("mouseleave", this.hoverOut);
    });
  }

  hoverIn = (event) => {
    const hoverId = event.currentTarget.dataset.hoverId;
    this.toggleHighlight(hoverId, true);
  };

  hoverOut = (event) => {
    const hoverId = event.currentTarget.dataset.hoverId;
    this.toggleHighlight(hoverId, false);
  };

  toggleHighlight(hoverId, shouldHighlight) {
    document.querySelectorAll(`[data-hover-id="${hoverId}"]`).forEach((el) => {
      if (el.nodeName === "TR") {
        el.classList.toggle("table-info", shouldHighlight);
      }
      if (el.nodeName === "LI") {
        el.classList.toggle("list-group-item-info", shouldHighlight);
      }
    });
  }
}
